import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { PHONE, PHONE_TEL, EMAIL } from "../../lib/seo";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/request-a-screening", label: "Request a Screening" },
];

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#12294D] text-white">
    <div className="grain-overlay" />
    <div className="relative mx-auto max-w-7xl px-5 pb-10 pt-16 lg:px-8">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-display text-3xl font-extrabold tracking-tight">
            Vera<span className="text-[#4FB3A5]">Screen</span>
            <span className="block text-sm font-medium tracking-[0.3em] text-white/60">SOLUTIONS</span>
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
            Verified Results. Confident Decisions.
          </p>
        </div>

        <nav className="flex flex-col gap-3">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B8962E]">Navigate</p>
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className="w-fit text-sm text-white/80 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex flex-col gap-3 text-sm text-white/80">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B8962E]">Contact</p>
          <a href={PHONE_TEL} data-testid="footer-phone" className="flex items-center gap-2.5 transition-colors duration-200 hover:text-white">
            <Phone size={16} className="shrink-0 text-[#4FB3A5]" strokeWidth={1.5} />
            {PHONE}
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="flex items-center gap-2.5 transition-colors duration-200 hover:text-white">
            <Mail size={16} className="shrink-0 text-[#4FB3A5]" strokeWidth={1.5} />
            {EMAIL}
          </a>
          <p className="flex items-start gap-2.5">
            <MapPin size={16} className="mt-0.5 shrink-0 text-[#4FB3A5]" strokeWidth={1.5} />
            Washington DC&nbsp;|&nbsp;Maryland&nbsp;|&nbsp;Northern Virginia
          </p>
        </div>
      </div>

      <p
        aria-hidden="true"
        className="font-display pointer-events-none mt-16 select-none whitespace-nowrap text-center text-[13vw] font-extrabold leading-none tracking-tight text-white/[0.045]"
      >
        VERASCREEN
      </p>

      <div className="mt-6 border-t border-white/10 pt-6 text-center text-xs text-white/50">
        A Division of The Allicock Group&nbsp;&nbsp;|&nbsp;&nbsp;© 2025 VeraScreen Solutions LLC
      </div>
    </div>
  </footer>
);
